import { createI18n } from "vue-i18n";
import { get, merge } from "lodash-es";
import en from "@vee-validate/i18n/dist/locale/en.json";
import nl from "@vee-validate/i18n/dist/locale/nl.json";
import fr from "@vee-validate/i18n/dist/locale/fr.json";
import nb_NO from "@vee-validate/i18n/dist/locale/nb_NO.json";
import de from "@vee-validate/i18n/dist/locale/de.json";

export default async function setupI18N(locale: string) {
    let jsonEnTranslations = await import("../../base/lang/en_GB.json");
    let jsonEnValidations = {
        fields: {
            firstname: "firstname",
            lastname: "lastname",
            postalcode: "postalcode",
            street_number: "street number",
            addition: "addition",
            street: "street",
            city: "city",
            email: "e-mail",
            telephone: "phone",
        },
        validation: en.messages,
    };

    let activeLocales = null;

    switch (locale.toLowerCase()) {
        case "nb_no":
            let jsonNoTranslations = await import("../../base/lang/nb_NO.json");
            let jsonNoValidations = {
                fields: {
                    firstname: "fornavn",
                    lastname: "etternavn",
                    postalcode: "postnummer",
                    street_number: "husnummer",
                    addition: "addition",
                    street: "adresse",
                    city: "poststed",
                    email: "e.postadresse",
                    telephone: "telefonnummer",
                    invoice_housenumber: "husnummer",
                    invoice_postalcode: "postnummer",
                    invoice_street: "adresse",
                    invoice_city: "poststed",
                    password: "passord",
                    password_confirmation: "Bekreft passord",
                },
                validation: nb_NO.messages,
            };

            activeLocales = {
                en_GB: merge(jsonEnTranslations, jsonEnValidations),
                nb_NO: merge(jsonNoTranslations, jsonNoValidations),
            };
            break;
        case "nl_nl":
            let jsonNlTranslations = await import("../../base/lang/nl_NL.json");
            let jsonNlValidations = {
                fields: {
                    firstname: "voornaam",
                    lastname: "achternaam",
                    postalcode: "postcode",
                    street_number: "huisnummer",
                    addition: "toevoeging",
                    street: "straat",
                    city: "plaats",
                    email: "e-mailadres",
                    telephone: "telefonnummer",
                    invoice_housenumber: "huisnummer",
                    invoice_postalcode: "postcode",
                    invoice_street: "straat",
                    invoice_city: "plaats",
                    password: "wachtwoord",
                    password_confirmation: "Bevestig je wachtwoord",
                },
                validation: nl.messages,
            };

            activeLocales = {
                en_GB: merge(jsonEnTranslations, jsonEnValidations),
                nl_NL: merge(jsonNlTranslations, jsonNlValidations),
            };
            break;
        case "nl_be":
            let jsonBeTranslations = await import("../../base/lang/nl_BE.json");
            let jsonBeValidations = {
                fields: {
                    firstname: "voornaam",
                    lastname: "achternaam",
                    postalcode: "postcode",
                    street_number: "huisnummer",
                    addition: "toevoeging",
                    street: "straat",
                    city: "plaats",
                    email: "e-mailadres",
                    telephone: "telefonnummer",
                },
                validation: nl.messages,
            };

            activeLocales = {
                en_GB: merge(jsonEnTranslations, jsonEnValidations),
                nl_BE: merge(jsonBeTranslations, jsonBeValidations),
            };
            break;
        case "fr_fr":
            let jsonFrTranslations = await import("../../base/lang/fr_FR.json");
            let jsonFrValidations = {
                fields: {
                    firstname: "prénom",
                    lastname: "nom de famille",
                    postalcode: "code postal",
                    street_number: "numéro de rue",
                    addition: "addition",
                    street: "rue",
                    city: "ville",
                    email: "email",
                    telephone: "téléphone",
                    invoice_housenumber: "numéro de rue",
                    invoice_postalcode: "code postal",
                    invoice_street: "rue",
                    invoice_city: "ville",
                    password: "mot de passe",
                    password_confirmation: "Confirmer votre mot de passe",
                },
                validation: fr.messages,
            };

            activeLocales = {
                en_GB: merge(jsonEnTranslations, jsonEnValidations),
                fr_FR: merge(jsonFrTranslations, jsonFrValidations),
            };
            break;
    }

    return createI18n({
        legacy: true,
        locale: window.wordpress_locale,
        fallbackLocale: "en_GB", // set fallback locale
        messages: activeLocales,
        messageResolver: (obj, path) => {
            // Parse to string to prevent running `replaceAll` on a numerical value
            // Run `replaceAll` to work around the reserved character `@` in the I18N implementation
            return get(obj, path, "")?.toString()?.replaceAll(/@/g, "{'@'}") || null;
        },
    });
}
